import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { NewsSubscribeForm } from '../../components/SubscribeForms';
import { useEventTracking, useIntersectionObserver, validateEmail } from '../../utils';
import { subscribe } from '../../reducers/modules/subscribe/subscribe';
import { selectIsSubscribed } from '../../selectors/subscription/selectIsSubscribed';
import { TDispatch } from '../../types/redux';

/** Форма подписки на новости */
export const NewsSubscribeFormContainer = () => {
  const [isInvalid, setIsInvalid] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isIntersectionObserverFrozen, setIsIntersectionObserverFrozen] = useState(false);
  const entry = useIntersectionObserver(wrapperRef, { freezeOnceVisible: isIntersectionObserverFrozen });
  const isSubscribed = useSelector(selectIsSubscribed);
  const dispatch = useDispatch<TDispatch>();
  const { trackEventSite } = useEventTracking({
    category: 'magazine',
    label: 'email_subscription',
    page: {
      extra: {
        bannerName: 'magazine_email_subscription',
        trap_type: 'banner',
      },
    },
  });

  /** Трекает показ однократно */
  useEffect(() => {
    if (isIntersectionObserverFrozen || !entry?.isIntersecting) {
      return;
    }

    trackEventSite({
      action: 'show_sopr',
    });

    setIsIntersectionObserverFrozen(true);
  }, [entry, isIntersectionObserverFrozen, trackEventSite]);

  const handleSubmit = useCallback(
    (email: string) => {
      if (!validateEmail(email)) {
        setIsInvalid(true);

        return;
      }

      dispatch(subscribe(email));

      trackEventSite({
        action: 'click',
      });
    },
    [dispatch, trackEventSite],
  );

  // В момент введения данных в инпут выключаем валидацию
  const handleChange = useCallback(() => {
    setIsInvalid(false);
  }, []);

  return (
    <div ref={wrapperRef}>
      <NewsSubscribeForm
        onSubmit={handleSubmit}
        onChange={handleChange}
        isInvalid={isInvalid}
        isSubscribed={isSubscribed}
      />
    </div>
  );
};
